import React, { FC, useRef, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import LogoutIcon from "@mui/icons-material/Logout";
import { useRouter } from "next/router";
import {
    ErrorOutlineRounded,
    InsertDriveFileOutlined,
    Person2Outlined,
    SettingsSuggestOutlined,
} from "@mui/icons-material";

interface MenuContentProps {
    handleMenuClose: () => void;
    setOpen: any;
}

const MenuContent: FC<MenuContentProps> = ({ handleMenuClose, setOpen }) => {
    const router = useRouter();
    const [isFeedbackFormOpen, setIsFeedbackFormOpen] = useState(false);
    const [formError, setFormError] = useState<any>("");

    const feedbackRef = useRef<any>();
    const handleToggleFeedbackForm = () => {
        setIsFeedbackFormOpen(!isFeedbackFormOpen);
        setFormError("");
    };
    const handleFeedbackFormSubmit = () => {
        feedbackRef.current?.submitForm();
    };
    const handleLogout = () => {
        router.push("/login");
        setOpen(false);
    };

    return (
        <>
            <MenuItem className="font-bold mb-[0.5rem]">
                {/* Welcome {profileMainData?.firstName}! */}
            </MenuItem>
            <MenuItem
                onClick={() => {
                    router.push("/client/profile");
                    handleMenuClose();
                }}
            >
                <ListItemIcon>
                    <Person2Outlined fontSize="medium" />
                </ListItemIcon>
                My Profile
            </MenuItem>
            <Divider />

            <MenuItem
                onClick={() => {
                    router.push("/library");
                    handleMenuClose();
                }}
            >
                <ListItemIcon>
                    <InsertDriveFileOutlined fontSize="medium" />
                </ListItemIcon>
                My Library
            </MenuItem>
            <Divider />
            <MenuItem
                onClick={() => {
                    router.push("/settings");
                    handleMenuClose();
                }}
            >
                <ListItemIcon>
                    <SettingsSuggestOutlined fontSize="medium" />
                </ListItemIcon>
                Company Profile
            </MenuItem>
            <Divider />
            <MenuItem
                onClick={() => {
                    handleToggleFeedbackForm();
                }}
            >
                <ListItemIcon>
                    <ErrorOutlineRounded fontSize="medium" />
                </ListItemIcon>
                Feedback
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                    <LogoutIcon fontSize="medium" />
                </ListItemIcon>
                Logout
            </MenuItem>
        </>
    );
};

export default MenuContent;
